// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";
import "flowbite/dist/flowbite.turbo.js";
// import "./channels"; // Uncomment this line if you want to use custom Channels
